 
export enum EntryMode {
  Automatic = 0,
  Manual = 1
}


// WEBPACK FOOTER //
// ./src/types/entry-mode.ts